import schema from "../../../../../app/graphql/schema.json";

export default schema.data.__schema.types.reduce((memo, supertype) => {
  const pt = { ...memo };
  if (supertype.possibleTypes) {
    pt[supertype.name] = supertype.possibleTypes.map(subtype => subtype.name);
  }

  return pt;
}, {});
